import { render, staticRenderFns } from "./UpcomingEvent.vue?vue&type=template&id=be81c14a&scoped=true&"
import script from "./UpcomingEvent.vue?vue&type=script&lang=js&"
export * from "./UpcomingEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be81c14a",
  null
  
)

export default component.exports